
// 西药库存预警 接口相关的函数
import request from "@/untils/request.js"

/**
 * 
 *  post
 *  
 */

// 新增库存预警-保存 => 西药库
export const alert = (data) => {
    return request.post("/outpatient/alert", data )
}

// 新增库存预警-保存 => 西药房
export const alertXYF = (data) => {
    return request.post("/outpatient/pharmacyAlert", data )
}

// 新增库存预警-保存 => 中药库
export const alertZYK = (data) => {
    return request.post("/outpatient/tcmAlert", data )
}

// 新增库存预警-保存 => 中药房
export const alertZYF = (data) => {
    return request.post("/outpatient/tcmAlert", data )
}
/**
 * 
 * put
 *  
 */


/**
 * 
 * get 
 *  
 */

// 库存预警列表 = 。西药库
export const alertList = (data) => {
    return request.get("/outpatient/alert/list", data )
}
// 设置库存预警数量列表 = 。西药库
export const alertPages = (params) => {
    return request.get("/outpatient/alert/pages", { params } )
}

// 库存预警列表 = 。西药房
export const alertListXYF = (data) => {
    return request.get("/outpatient/pharmacyAlert/list", data )
}
// 设置库存预警数量列表 = 。西药房
export const alertPagesXYF = (params) => {
    return request.get("/outpatient/pharmacyAlert/pages", { params } )
}

// 库存预警列表 = 。中药库
export const alertListZYK = (data) => {
    return request.get("/outpatient/tcmAlert/list", data )
}
// 设置库存预警数量列表 = 。中药库
export const alertPagesZYK = (data) => {
    return request.get("/outpatient/tcmAlert/pages", data )
}

// 库存预警列表 = 。中药房
export const alertListZYF = (data) => {
    return request.get("/outpatient/tcmAlert/list", data )
}
// 设置库存预警数量列表 = 。中药房
export const alertPagesZYF = (data) => {
    return request.get("/outpatient/tcmAlert/pages", data )
}

/*
 * 
 * DELETE 
 *   
 */   

// 暴露
export default{
	alertList,alertPages,
	alert
}